import type { UsageTotals } from "@racler/protocol";

export function formatTokens(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 10_000) return `${(n / 1000).toFixed(1)}k`;
  return n.toLocaleString("en-US");
}

/** Cost is shown only when providers reported one; "partial" when some responses had no cost. */
export function formatCost(t: Pick<UsageTotals, "costUsd" | "costedMessages" | "responses">): {
  text: string;
  partial: boolean;
} {
  if (t.costUsd === null || t.costedMessages === 0) return { text: "not reported", partial: false };
  const text = t.costUsd < 0.01 ? `$${t.costUsd.toFixed(4)}` : `$${t.costUsd.toFixed(2)}`;
  return { text, partial: t.costedMessages < t.responses };
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
